<template>
  <div id="app">
    <div class="studio-shell" :class="{ 'chat-mode': isChatPage }">
      <left-bar />
      <div class="main">
        <top-bar v-show="!isChatPage" @load="loaded = true" />
        <div class="page-content" :class="{ 'secondary-page': isSecondaryPage }" v-if="loaded">
          <div class="legacy-intro" v-if="routeIntro">
            <h1>{{ routeIntro.title }}</h1>
            <p>{{ routeIntro.description }}</p>
          </div>
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import leftBar from "./components/layout/LeftBar.vue";
import topBar from "./components/layout/Top.vue";
export default {
  data() {
    return {
      loaded: false,
    };
  },
  computed: {
    routeIntro() {
      const pages = {
        '/race': ['插花比赛', '发布比赛、评分与数据分析'],
        '/race/editRace': [this.$route.query.id ? '编辑比赛' : '创建比赛', '配置比赛要求、素材、时间与参赛范围'],
        '/race/score': ['比赛评分', '查看参赛作品并完成评分'],
        '/race/data': ['比赛数据', '查看参赛完成情况与成绩统计'],
        '/homework': ['插花作业', '布置作业、查看提交并完成批阅'],
        '/homework/editHomeWork': [this.$route.query.id ? '编辑作业' : '创建作业', '配置作业要求、素材与提交规则'],
        '/homework/correctList': ['批阅作业', '查看学生作品与批阅进度'],
        '/homework/statusList': ['作业完成状态', '查看提交情况并发送提醒'],
        '/courseware': ['教学课件', '课程内容、发布范围与学习数据管理'],
        '/courseware/dataAnalysis': ['课件数据分析', '查看学生学习状态与时长'],
        '/manage': ['学生管理', '查看学生、标签与作品信息'],
        '/manage/class': ['标签管理', '维护标签、人数上限与学生归属'],
        '/manage/classDetail': ['标签详情', '查看和调整标签成员'],
        '/studentWorkList': ['学生作品', '查看与管理学生的数字插花作品'],
        '/teachingData': ['教学数据', '创作、比赛、课件与参与情况'],
        '/account': ['账号管理', '个人信息与学校账号设置'],
        '/future': ['课件', '教学资源与课程内容'],
      };
      const page = pages[this.$route.path];
      return page ? { title: page[0], description: page[1] } : null;
    },
    isChatPage() {
      return this.$route.path === '/ai-chat';
    },
    isSecondaryPage() {
      return [
        '/race',
        '/race/data',
        '/race/score',
        '/race/editRace',
        '/homework',
        '/homework/correctList',
        '/homework/statusList',
        '/homework/editHomeWork',
        '/manage',
        '/manage/class',
        '/manage/classDetail',
        '/studentWorkList',
        '/courseware/dataAnalysis',
        '/materials/flower/list',
        '/materials/flower/detail',
        '/materials/container/list',
        '/materials/container/detail',
        '/teachingData',
        '/account',
      ].includes(this.$route.path);
    },
  },
  components: {
    leftBar,
    topBar,
  },
};
</script>
<style lang="scss" scoped>
#app {
  .studio-shell {
    min-height: 100vh;
    display: flex;
    background: #f5f8f6;
  }
  .main {
    min-width: 0;
    flex: 1;
    margin-left: 246px;
  }
  .page-content {
    min-height: calc(100vh - 72px);
    padding: 28px 32px 48px;
  }
  .chat-mode .page-content { height: 100vh; min-height: 0; padding: 14px 18px; overflow: hidden; }
  .legacy-intro { margin-bottom: 24px; }
  .legacy-intro h1 { margin: 0; color: #18201c; font-size: 28px; font-weight: 700; }
  .legacy-intro p { margin: 8px 0 0; color: #89948d; font-size: 14px; }
  @media (max-width: 900px) {
    .main { margin-left: 72px; }
    .page-content { padding: 22px; }
  }
  @media (max-width: 640px) {
    .main { margin-left: 0; }
    .page-content { padding: 16px; }
  }
}
</style>
